const state = {
    // pricingSectorReq: null,
    // pricingSectorRes: null,
    // pricingAllClassesReq: null,
    // pricingAllClassesRes: null,
    selectedPricingObj: null,
    selectedPricingTier: null,
    selectedPricTierName:null,
    selectedMarkupPricing:null,

};

const getters = {
    // GET_PRICING_SECTOR_REQ: () => {
    //     return state.pricingSectorReq;
    // },
    // GET_PRICING_SECTOR_RES: () => {
    //     return state.pricingSectorRes;
    // },

    // GET_PRICING_CLASSES_REQ: () => {
    //     return state.pricingAllClassesReq;
    // },
    // GET_PRICING_CLASSES_RES: () => {
    //     return state.pricingAllClassesRes;
    // },
    GET_SELECTED_PRICING: (state) => {
        return state.selectedPricingObj;
    },
    GET_SELECTED_TIER: (state) => {
        return state.selectedPricingTier;
    },
    GET_SEL_TIER_NAME: (state) => {
        return state.selectedPricTierName;
    },

    GET_SEL_MARKUP_PRICING :(state) =>{
        return state.selectedMarkupPricing
    }
};

const actions = {
    CLEAR_CREATE_PRICING_STORE: ({ commit }) => {
        commit('clearStore')
    },

    // SET_PRICING_SECTOR_REQ: ({ commit }, req) => {
    //     commit("saveSectorReq", req);
    // },
    // SET_PRICING_SECTOR_RES: ({ commit }, res) => {
    //     commit("saveSectorRes", res);
    // },

    // SET_PRICING_CLASSES_REQ: ({ commit }, req) => {
    //     commit("saveClassesReq", req);
    // },
    // SET_PRICING_CLASSES_RES: ({ commit }, res) => {
    //     commit("saveClassesRes", res);
    // },
    SET_SELECTED_PRICING: ({ commit }, selectedPricingObj) => {
        commit("saveSelectedPricing", selectedPricingObj);
    },
    SET_SELECTED_TIER: ({ commit }, selectedTier) => {
        commit('saveSelectedTier', selectedTier);
    },
    SET_SEL_TIER_NAME: ({ commit }, selTierName) => {
        commit('saveSelTierName', selTierName);
    },

     SET_SEL_MARKUP_PRICING:({commit},markup) =>{

        commit('saveSelMarkupPricing',markup);
     }  



};

const mutations = {

    clearStore: (state) => {
        // state.pricingAllClassesReq = null;
        // state.pricingAllClassesRes = null;
        // state.pricingSectorReq = null;
        // state.pricingSectorRes = null;
        state.selectedPricingObj = null;
        state.selectedPricingTier = null
        state.selectedPricTierName=null
        state.selectedMarkupPricing=null
    },
    // saveSectorReq: (state, req) => {
    //     state.pricingSectorReq = req;
    // },

    // saveSectorRes: (state, res) => {
    //     state.pricingSectorRes = res;
    // },
    // saveClassesReq: (state, req) => {
    //     state.pricingAllClassesReq = req;
    // },
    // saveClassesRes: (state, res) => {
    //     state.pricingAllClassesRes = res;
    // },
    saveSelMarkupPricing(state,val)  {
        state.selectedMarkupPricing=val
    },
    saveSelectedPricing(state, selectedPricingObj) {
        state.selectedPricingObj = selectedPricingObj;
    },
    saveSelectedTier(state, selectedTierObj) {
        state.selectedPricingTier = selectedTierObj;
    },
    saveSelTierName(state, selTierName) {
        state.selectedPricTierName = selTierName;
    }

};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};